import { SelectFilter } from './select-filter.class';

export class YearSelectFilter extends SelectFilter {
    selectYear(year: number): void {
        this.selected = this.options.find((option) => option.value === year);
        this.emitValueChange();
    }

    protected emitValueChange(): void {
        const from = this.selected.value ? `${this.selected.value}-01-01` : null;
        const to = this.selected.value ? `${this.selected.value}-12-31` : null;

        this.onChanges.next([
            { field: `${this.filterField}.from`, value: `${from}` },
            { field: `${this.filterField}.to`, value: `${to}` },
        ]);
    }
}
